export default "__VITE_ASSET__CatPTGyl__"